import { render, staticRenderFns } from "./RecipeCollectionView.vue?vue&type=template&id=686d5334&scoped=true"
import script from "./RecipeCollectionView.vue?vue&type=script&lang=js"
export * from "./RecipeCollectionView.vue?vue&type=script&lang=js"
import style0 from "./RecipeCollectionView.vue?vue&type=style&index=0&id=686d5334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d5334",
  null
  
)

export default component.exports